// core (MUI)
import { svSE as svSECore } from '@mui/material/locale';
// data grid (MUI)
import { enUS as enUSDataGrid, svSE as svSEDataGrid } from '@mui/x-data-grid/locales';
// date pickers (MUI)
import { enUS as enUSDate, svSE as svSEDate } from '@mui/x-date-pickers/locales';

export const allLangs = [
    {
        value: 'en',
        label: 'English',
        countryCode: 'GB',
        adapterLocale: 'en',
        numberFormat: { code: 'en-US', currency: 'USD' },
        systemValue: {
            components: { ...enUSDate.components, ...enUSDataGrid.components },
        },
    },
    {
        value: 'sv',
        label: 'Svenska',
        countryCode: 'SE',
        adapterLocale: 'sv',
        numberFormat: { code: 'sv-SE', currency: 'SEK' },
        systemValue: {
            components: {
                ...svSECore.components,
                ...svSEDate.components,
                ...svSEDataGrid.components,
            },
        },
    },
];

/**
 * Country code:
 * https://flagcdn.com/en/codes.json
 *
 * Number format code:
 * https://gist.github.com/raushankrjha/d1c7e35cf87e69aa8b4208a8171a8416
 */
